import React, { useRef, useEffect } from "react";
import { Container } from "./styles";

const Popover = ({
  triggerComponent,
  dropdown,
  right = 0,
  left,
  top = "82px",
  fixed = false,
  containerStyle,
  showDropdown,
  onClose,
  menuIconStyle,
  hideTriangle = false
}) => {
  const popoverRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = event => {
      if (
        popoverRef.current &&
        !popoverRef.current.contains(event.target) &&
        onClose
      ) {
        onClose();
      }
    };
    if (showDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDropdown, onClose]);

  return (
    <Container
      style={containerStyle}
      ref={popoverRef}
      right={right}
      menuLeft={left}
      top={top}
      fixed={fixed}
      iconStyle={Boolean(menuIconStyle)}
    >
      {triggerComponent}
      {showDropdown && (
        <div className="menu">
          <div className="inner">
            {!hideTriangle && (
              <img
                src={require("../../assets/triangle.svg")}
                className="triangle"
                alt={"menu"}
              />
            )}
            {dropdown}
          </div>
        </div>
      )}
    </Container>
  );
};

export default Popover;
